import Route from "@ember/routing/route";
import { restartableTask, enqueueTask } from "ember-concurrency";
import { service } from "@ember/service";
import RSVP from "rsvp";
import { query } from "@warp-drive/legacy/compat/builders";
import ENV from "glesys-controlpanel/config/environment";

export default class EmailOverviewRoute extends Route {
  @service ajax;
  @service store;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  queryParams = {
    page: {
      refreshModel: true,
    },
    filter: {
      refreshModel: true,
    },
  };

  model({ page, filter }) {
    let { project, organization } = this.modelFor("organization");

    return RSVP.hash({
      project,
      dnsDomains: project.get("dnsDomains"),
      pricelist: this.ajax.request(`${ENV.apiBaseUri}/domain/pricelist?organizationnumber=${organization.id}`),
      domainsTaskResult: this.fetchDomainsTask.perform(project, page, filter),
    });
  }

  resetController(controller) {
    controller.setProperties({
      page: 1,
      filter: "",
    });
  }

  fetchDomainsTask = restartableTask(async (project, page, filter) => {
    return this.store
      .request(query("email-domain", { projectkey: project.get("id"), page, filter }))
      .then(({ content: domains }) => {
        domains.forEach((domain) => this.fetchDomainMailServerTask.perform(domain));
        return domains;
      });
  });

  fetchDomainMailServerTask = enqueueTask({ maxConcurrency: 3 }, async (domain) => {
    await domain.fetchMailServer();
  });
}
